/**
 * 职业类型
 */
export enum JobType {
  /* 一转 */
  Type1 = 'first_transfer',
  /* 二转 */
  Type2 = 'second_transfer',
  /* 二之二转 */
  Type22 = 'second_transfer_second',
  /* 二转进阶 */
  Type2s = 'second_advanced_transfer',
  /* 进阶二之二转 */
  Type2s2 = 'second_advanced_transfer_second',
  /* 三转 */
  Type3 = 'third_transfer',
  /* 二之三转 */
  Type32 = 'third_transfer_second',
}

export enum Sex {
  Male = 'male',
  Female = 'female',
}

export interface JobsRespItem {
  id: string
  name: string
  name_male?: string
  name_female?: string
  desc: string
  desc_male?: string
  desc_female?: string
  en_name?: string
  /* 立绘 */
  img_male: string
  /* 立绘 */
  img_female: string
  /* 人物模型 */
  model_male: string
  /* 人物模型 */
  model_female: string
  /* line img */
  line_male: string
  /* line img */
  line_female: string
  /* 头像 */
  avatar_male: string
  /* 头像 */
  avatar_female: string
  /* 头像-选中状态 */
  avatar_male_selected: string
  /* 头像-选中状态 */
  avatar_female_selected: string
  /* 类型  一转、二转、二转进阶 */
  type: JobType
  /* 职业对应的小图标 */
  icon?: string
  /* 职业对应的小图标--选中状态 */
  icon_selected?: string
  /** 六维图 */
  map: string
  sub_role?: JobsRespItem[]
}

export type JobResp = JobsRespItem[]
